const edgeStyle = (kind, data, edgeSizeMap) => {
  if (typeof data === 'string') {
    return `
      ${kind}: ${edgeSizeMap[data] || data};
    `;
  }

  const result = [];

  if (data.horizontal) {
    result.push(`
      ${kind}-left: ${edgeSizeMap[data.horizontal] || data.horizontal};
      ${kind}-right: ${edgeSizeMap[data.horizontal] || data.horizontal};
    `);
  }

  if (data.vertical) {
    result.push(`
      ${kind}-top: ${edgeSizeMap[data.vertical] || data.vertical};
      ${kind}-bottom: ${edgeSizeMap[data.vertical] || data.vertical};
    `);
  }

  if (data.top) {
    result.push(`
      ${kind}-top: ${edgeSizeMap[data.top] || data.top};

    `);
  }

  if (data.bottom) {
    result.push(`
      ${kind}-bottom: ${edgeSizeMap[data.bottom] || data.bottom};

    `);
  }

  if (data.left) {
    result.push(`
      ${kind}-left: ${edgeSizeMap[data.left] || data.left};
    `);
  }

  if (data.right) {
    result.push(`
      ${kind}-right: ${edgeSizeMap[data.right] || data.right};
      `);
  }

  return result;
};

export default edgeStyle;
